<div class="main-wrapper">
    <div class="top">
        <img height="50px" width="150px" src="/assets/logo 3.svg" />
    </div>
    <div>
        <p class="title2">
            Welcome
        </p>
    
        <p class="description">
            The platform you’re trying to access is only<br/> available on desktop. 
        </p>
    
        <p class="cta">
    See you there!
        </p>
    </div>
    
    <div class="bottom">
    <p class="contact">
        Contact us
    </p>
    <p class="contact-text">
        +387 62 345 678<br/><br/>
        support@companyinclouds.com
    </p>
    </div>
</div>
<div class="main-wrapper">
    <div class="top">
        <img width="200px" src="/assets/logo 3.svg" />
    </div>
    <div>
        <div class="title">
            Welcome
        </div>
    
        <p class="description">
            The platform you’re trying to access is only<br/> available on desktop. 
        </p>
    
        <p class="cta">
    See you there!
        </p>
    </div>
    
    <div class="bottom">
    <p class="contact">
        Contact us
    </p>
    <p class="contact-text">
        +387 62 345 678<br/><br/>
        support@companyinclouds.com
    </p>
    </div>
</div>
